module.exports = __webpack_public_path__ + "img/Motion.f25cea31.png";